<!-- form btns-->
<section class="tw-mt-[15px]">
  <div class="tw-flex tw-justify-end">
    <div class="tw-flex tw-justify-end tw-h-[70%] tw-w-full" style="max-width: 275px;">

      <!-- cancel btn -->
      <a *ngIf="input_showCloseBtn" mat-ripple class="btn tw-ml-[5px] ltr:tw-mr-[5px] tw-w-1/2  button-shadow tw-h-[70%]"
        [class]="getCloseBtnBgColor()" (click)="onClose()">
        {{'common.cancel'|translate}}
      </a>

      <!-- submit btn -->
      <button [type]="input_type" (click)="onSubmit()" mat-ripple
        class="btn tw-w-full tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-mb-1 tw-h-[70%]"
        [ngClass]="((input_submitBgColor == 'danger') || (input_submitBgColor =='success'))?('btn-'+input_submitBgColor):''"
        [themeColor]="'btn'" [isAllowSetTheme]="true"
        [disabled]="input_isDisabled">

        <ng-container *ngIf="!input_loading">
          <ng-container *ngIf="!input_customTitle">
            <span *ngIf="!input_isEdit"> {{'common.submit'|translate}}</span>
            <span *ngIf="input_isEdit">{{'common.edit'|translate}}</span>
          </ng-container>
          <ng-container *ngIf="input_customTitle">
            <span class="submit-button-text-color"> {{input_customTitle|translate}}</span>
          </ng-container>
        </ng-container>

        <!-- loading -->
        <ng-container *ngIf="input_loading">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span class="sr-only">Loading...</span>
        </ng-container>

      </button>
    </div>
  </div>
</section>
